import { NotesFieldsArrayView } from '../../../../types/form-types'
import '../../../../styles/4-layout/_note-container.scss'
import Note from './note'
import { Heading } from '@msaf/core-react'

interface NotesWrapperProps {
  notes: Partial<NotesFieldsArrayView>
  isLoading: boolean
}

// Maybe merge this component with NotesWrapperEdit? Seems cleaner to have is separated
export default function NotesWrapperView({ notes, isLoading }: NotesWrapperProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={2}>
        Notes
      </Heading>
      <div className='c-notes-container'>
        {notes.map((note, idx) => (
          <Note note={note} key={idx} isLoading={isLoading} idx={idx} editMode={false} />
        ))}
      </div>
    </>
  )
}
